import { UsePlanAnualContext } from "#training/contexts/AnnualPlanCreateContext"
import { Button, Stack } from "@mui/material"
import Card from "@mui/material/Card"
import Typography from "@mui/material/Typography"
import AnnualPlanCreateListaCursosDrag from "./AnnualPlanCreateListaCursosDrag"
import { useCallback, useState } from "react"
import { useApiSend } from "#hooks/useApiSend"
import { annualPlanPost } from "#training/services/Api"

export default function AnnualPlanCreateListaDrop() {
	return (
		<Stack spacing={3} justifyItems="center" alignItems="center">
			<Stack direction={"row"} spacing={1} width={"100%"}>
				<TarjetasMesesDrop />
				<AnnualPlanCreateListaCursosDrag />
			</Stack>
			<ButtonSend />
		</Stack>
	)
}
const ButtonSend = () => {
	const { cursosIds, selectAreas, setReload, setSelectAreas, setCursosIds } =
		UsePlanAnualContext()
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setReload((old) => !old)
		setSelectAreas([])
		setCursosIds([])
	}

	const { fetch } = useApiSend(annualPlanPost, {
		success,
		end: () => setDisabled(false),
	})

	const handleSend = useCallback(() => {
		setDisabled(true)
		const send = cursosIds.map((item, index) => ({
			curso_id: item,
			month: index + 1,
		}))

		fetch({ cursos: send, areas_id: selectAreas }, { Plan_Anual: true })
	}, [cursosIds, fetch, selectAreas])

	if (cursosIds.length !== 12) return null
	return (
		<Button disabled={disabled} onClick={handleSend}>
			Crear plan anual
		</Button>
	)
}

const meses = [
	{ id: 1, label: "Enero" },
	{ id: 2, label: "Febrero" },
	{ id: 3, label: "Marzo" },
	{ id: 4, label: "Abril" },
	{ id: 5, label: "Mayo" },
	{ id: 6, label: "Junio" },
	{ id: 7, label: "Julio" },
	{ id: 8, label: "Agosto" },
	{ id: 9, label: "Septiembre" },
	{ id: 10, label: "Octubre" },
	{ id: 11, label: "Noviembre" },
	{ id: 12, label: "Diciembre" },
]
function TarjetasMesesDrop() {
	const { cursosIds } = UsePlanAnualContext()
	if (cursosIds.length !== 12) return null
	return (
		<Stack spacing={1}>
			{meses.map((mes, index) => (
				<Card
					style={{
						height: 32,
						minWidth: "7vw",
					}}
				>
					<Typography
						component="h4"
						variant="poster"
						align="center"
						alignItems="center"
						style={{
							paddingTop: 5,
							height: "100%",
							width: "100%",
						}}
					>
						{mes.label}
					</Typography>
				</Card>
			))}
		</Stack>
	)
}
